export default {
    methods: {
        csrfToken() {
            return document.getElementsByTagName('meta')['csrf-token'].content;
        },

        authUser() {
            return App.authUser;
        },

        responseHasValidationErrors(error) {
            return (
                error.response && error.response.status == 422 && Object.prototype.hasOwnProperty.call(error.response.data, error)
            );
        },

        flattedErrors(error) {
            if (this.responseHasValidationErrors(error)) {
                return _.flatten(_.values(error.response.data.errors));
            }
        }
    }
};
